import { IUserMilestone } from '../../IUserMilestone';

/**
 * Brand user has seen the Decagon AI chatbot tooltip
 * @protobufOption (milestoneType) = BRAND
 */
export const BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN =
  'BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN' as IUserMilestone.BrandMilestone;

export const Extensions = {
  milestoneType: `BRAND`,
};
